export default __webpack_public_path__ + "static/media/grapes.18aa6da0.png";